<template>
  <div class="w-screen h-full bg-white">
    <img src="/bg-model_4k.webp" v-if="showBackground" class="fixed top-0 left-0 w-full h-full object-cover" />
    <body-viewer
      v-if="recordToShow"
      :record="recordToShow"
      :disableClose="true"
      @show-record="openRecordViewer"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { wait } from '@/modules/utils';
import { EVENTS as UI_EVENTS } from '@/events/ui';
import ApiActions from '@/modules/api-actions';
import BodyViewer from '@/components/DefaultCloudzet/HomePage/BodyViewer.vue';

export default {
  name: 'Share',
  components: {
    BodyViewer,
  },
  data() {
    return {
      recordToShow: false,
      showBackground: false,
    };
  },
  mounted() {
    this.$events.once(UI_EVENTS.APP_MOUNTED, () => {
      this.getScanRecords();
    });
  },
  methods: {
    ...mapActions('user', ['getAllKindsOfScanRecords', 'clearScanRecords']),
    openRecordViewer(record) {
      this.recordToShow = record;
    },
    async getScanRecords() {
      this.showBackground = true;
      this.$events.startLoading();
      try {
        await this.clearScanRecords(0);
        await Promise.all([
          ApiActions.user.getProfile().catch(() => { throw Error('voucher_expired'); }),
          ApiActions.mtm.getScannersConfigs().catch(() => { }),
        ]);

        await this.getAllKindsOfScanRecords();
        if (!this.latestBodyRecord) {
          throw Error('no_scan_data');
        }
        this.showBackground = false;
        this.recordToShow = this.latestBodyRecord;
      } catch (e) {
        if (e.message === 'no_scan_data') {
          this.$events.alert(this.$t('share.no_scan_data'));
        }
        else if (e.message === 'voucher_expired') {
          this.$events.alert(this.$t('share.voucher_expired'));
        }
        else {
          console.log(e.message);
          this.$events.alert(this.$t('welcome.unexpected_error'));
        }
      }
      finally {
        this.$events.stopLoading();
      }
    },
  },
  computed: {
    ...mapGetters('user', ['latestBodyRecord']),
  },
};
</script>

<style lang="scss" scoped></style>
